import { Controller } from "@hotwired/stimulus"

// API トークン表示フィールド。マスク表示 / 表示切替 / クリップボードコピーを扱う。
//
//   <div data-controller="token-field" data-token-field-token-value="abc123">
//     <code data-token-field-target="display">••••••••</code>
//     <button data-action="token-field#toggle">
//       <span data-token-field-target="eyeIcon">…</span>
//       <span data-token-field-target="eyeOffIcon" class="hidden">…</span>
//     </button>
//     <button data-action="token-field#copy">
//       <span data-token-field-target="copyLabel">コピー</span>
//     </button>
//   </div>
export default class extends Controller {
  static targets = ["display", "eyeIcon", "eyeOffIcon", "copyLabel"]
  static values  = { token: String }

  connect() {
    this.revealed = false
    this.render()
  }

  toggle() {
    this.revealed = !this.revealed
    this.render()
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.tokenValue)
      this.flashCopied()
    } catch (_e) {
      // clipboard API が使えない環境 (非 HTTPS 等) は選択用に一時表示
      this.revealed = true
      this.render()
      window.prompt("このトークンをコピーしてください", this.tokenValue)
    }
  }

  render() {
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = this.revealed
        ? this.tokenValue
        : "•".repeat(Math.max(this.tokenValue.length, 8))
    }
    // revealed のときは「隠す (eye-off)」、非表示のときは「表示する (eye)」を見せる
    if (this.hasEyeIconTarget)    this.eyeIconTarget.classList.toggle("hidden", this.revealed)
    if (this.hasEyeOffIconTarget) this.eyeOffIconTarget.classList.toggle("hidden", !this.revealed)
  }

  flashCopied() {
    if (!this.hasCopyLabelTarget) return
    const original = this.copyLabelTarget.textContent
    this.copyLabelTarget.textContent = "コピーしました"
    setTimeout(() => { this.copyLabelTarget.textContent = original }, 1500)
  }
}
